import {
  colorCss,
  fontSizeCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { FieldIconNewUiInterface } from '../field-icon-new-ui.schema'

export interface FieldIconUiStylesInterface extends FieldIconNewUiInterface {}

export const FieldIconUi = styled.i<FieldIconUiStylesInterface>`
  color: initial;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
  && {
    position: absolute;
  }
  ${colorCss}
  ${fontSizeCss}

  ${p => p.theme.phone} {
    right: 10px;
    ${mobileColorCss}
    ${mobileFontSizeCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      left: 10px;
      ${mobileColorCss}
      ${mobileFontSizeCss}
    `}
`
